import type { GameManifest } from '@adgf/shared';
import { GameStatus } from '@adgf/shared';

const manifest: GameManifest = {
  id: 'c9d0e1f2-a3b4-4c5d-8e9f-0a1b2c3d4e5f',
  slug: 'sniper-range',
  title: 'Sharpshooter',
  description: 'Mouse-controlled sniper game. Aim, shoot, upgrade. Hit targets at different ranges for big points.',
  version: '0.1.0',
  template_id: 'sniper',
  runtime: 'phaser',
  status: GameStatus.DRAFT,
  difficulty: 'medium',
  duration: 60,
  features: ['sniper', 'mouse-aim', 'upgrade', 'precision', 'shooting'],
  entrypoint: 'phaser:sniper-range',
  analytics_schema: {
    events: ['game_open', 'game_start', 'shoot', 'hit', 'miss', 'target_spawn', 'upgrade_purchase', 'game_over'],
  },
};

export default manifest;
